module.exports = __webpack_public_path__ + "img/situationship.6aef3c7d.jpg";